import { css } from 'styled-components';

export const fullColorBackground = (backgroundColor: string) => css`
  background: ${backgroundColor};
  box-shadow: 0 0 0 100vmax ${backgroundColor};
  clip-path: inset(0 -100vmax);
`;
